import * as React from 'react';
import { SVGProps } from 'react';
import styled from 'styled-components';

const SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.354 1.33a3.76 3.76 0 0 1 2.595.394c.4.222.754.511 1.051.853a3.89 3.89 0 0 1 1.051-.853 3.76 3.76 0 0 1 2.595-.395 3.85 3.85 0 0 1 2.236 1.397c.563.716.868 1.607.868 2.524 0 2.458-1.712 4.586-3.237 6.016a19.813 19.813 0 0 1-3.112 2.368l-.016.01-.005.002-.001.001-.379.221-.378-.22-.002-.002-.005-.002-.016-.01a6.26 6.26 0 0 1-.258-.16 19.808 19.808 0 0 1-2.854-2.209C2.962 9.837 1.25 7.709 1.25 5.25c0-.916.305-1.808.868-2.524A3.85 3.85 0 0 1 4.354 1.33Z"
      fill="currentColor"
    />
  </svg>
);

const StyledSvgHeart = styled(SVG)`
  font-size: ${props => (props.fontSize ? props.fontSize : '1.6rem')};
  color: ${({ color, theme }) =>
    color ? color : theme.colors.neutralColors.charcoal};
  vertical-align: middle;
  shape-rendering: inherit;
  transform: translate3d(0, 0, 0);
`;
export default StyledSvgHeart;
